import axios from "axios";

const BASE_URL = "https://us-central1-boltconcierge-2f0f9.cloudfunctions.net";

export function attemptSignIn(data) {
  const apiUrl = process.env.REACT_APP_API_URL;
  return axios.request({
    url: `${apiUrl}/token/`,
    method: "POST",
    withCredentials: true,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

export function refreshToken() {
  const apiUrl = process.env.REACT_APP_API_URL;
  // return axios.request({
  // 	url: `${apiUrl}/token/`,
  // 	method: 'POST',
  // 	withCredentials: true,
  // 	headers: {
  // 		Accept: 'application/json',
  // 		'Content-Type': 'application/json',
  // 	},
  // 	data,
  // });
  return {
    access: "Access",
    refresh: "Refresh",
  };
}

export function getCurrentUserDetail(token) {
  const apiUrl = process.env.REACT_APP_API_URL;
  const header = `Bearer ${token}`;
  return axios.request({
    url: `${apiUrl}/me/`,
    method: "GET",
    withCredentials: true,
    headers: {
      Accept: "application/json",
      Authorization: header,
    },
  });
}

export function attemptSignUp(data) {
  return axios.request({
    url: `/token/`,
    method: "POST",
    withCredentials: true,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}

export const sendVerificationCodeToEmail = async (
  brandName,
  firstName,
  email
) => {
  const body = { brandName, firstName, email };
  try {
    const res = await axios.post(
      `${BASE_URL}/ecosystem-sendVerificationCodeByEmail`,
      body
    );
    return res;
  } catch (err) {
    console.log("sendVerificationCodeToEmail() error", err);
    return err;
  }
};

export const validateEmailCode = async (userCodeInput, email) => {
  const body = { userCodeInput, email };
  try {
    const res = await axios.post(
      `${BASE_URL}/ecosystem-validateEmailCode`,
      body
    );
    return res;
  } catch (err) {
    console.log("validateEmailCode() error", err);
    return err;
  }
};



// WEBPACK FOOTER //
// ./src/api/AuthApi.js